import { app } from '../../../../bootstrap/core';
import { acceptableAccordionSectionComponent } from './acceptableAccordionSection.component';

app.component('acceptableAccordionSection', acceptableAccordionSectionComponent);
